
import AdminLeave from "../../views/pages/Employees/AdminLeave";
import AttendenceAdmin from "../../views/pages/Employees/Attendenceadmin";
import React, { useEffect, useState } from "react";
import { Outlet, Route, Routes, useLocation, useNavigate, matchPath } from "react-router-dom";
import Header from "../../views/layout/Header";
import Sidebar from "../../views/layout/Sidebar";
import AllEmpoyee from "../../views/pages/Employees/AllEmpoyee";
import { useSelector, useDispatch } from "react-redux";
import { fetchClients } from "../../Slices/clientSlice";
import Clients from "../../views/pages/Clients/Clients";
import Error404 from "../../views/pages/Error/Error404";
import Profile from "../../views/pages/Profile/Profile";
import Sales from "../../views/pages/Sales1";
import AdminTasks from "../../views/pages/Issues/AdminTasks";
import UserTasks from "../../views/pages/Issues/UserTasks";
import SaleDetails from "../../views/pages/Sales1/SaleDetails";
import SalesEmailHistory from "../../views/pages/Sales1/SalesEmailHistory";
import EmailTemplates from "../../views/pages/Sales1/EmailTemplates";
import LeadAnalytics from "../../views/pages/Sales1/LeadAnalytics";
import UnsubscribeHistory from "../../views/pages/Sales1/UnsubscribeHistory";
import Pipeline from "../../views/pages/Pipeline/Pipeline";
import MyManualReports from "../../views/pages/SalesManualReports/MyReportsPage";
import TeamManualReports from "../../views/pages/SalesManualReports/TeamReportsPage";
import { fetchDynamicRoutes } from "../../Slices/DyanamicRoute";
import Requests from "../../views/pages/Requests1/Requests";
import EmployeeReport from "../../views/pages/Designs/employeereport";
import ClientReport from "../../views/pages/Designs/clientreport";
import ClientList from "../../views/pages/Clients/ClientList";
import EmployeeListFilter from "../../components/EmployeeListFilter";
import BulkEmail from "../../views/pages/Mail/BulkEmail";

import FieldManager from "../../views/pages/Profile/options";
import ConditionMenu from "../../views/layout/conditionMenu";
import Loader from "../../views/pages/Loader/Loader";
import OverwritingHistory from "../../views/pages/Designs/OverwritingHistory";
import { fetchData } from "../../Slices/dataBucket";
import NotificationListener from "../../views/pages/Sales1/emailsocket";
import LeaveSettings from "../../views/pages/Employees/LeaveSetting";
import ConditionMenuRoute from "../../views/layout/daynamicRoutes";
import { fetchUserDetails } from "../../Slices/Thunk/LoginThunk";
import AttendanceEmployee from "../../views/pages/Employees/AttendenceEmployee";
import RequestsStats from "../../views/pages/Dashboards/RequestsStats";
import SalesStats from "../../views/pages/Dashboards/SalesStats";
import EmployeeLeave from "../../views/pages/Employees/EmployeeLeave";
import IDCard from "../../components/IdCardgenerater";
import Holidays from "../../views/pages/Employees/Holidays";
import ResetToken from "../../views/pages/ResetToken/resetToken"
import Announcements from "../../views/pages/Announcements/Announcements"
import MobileRouteManagement from "../../views/pages/AccessManagement/MobileRouteManagement"
import { ClientProfiles } from "../../views/pages/Clients/clientProfiles";
import { RecordClientReport } from "../../views/pages/Records/clientReports";
import { RecordEmployeeReport } from "../../views/pages/Records/EmployeeReports";
import { RecordTimeLog } from "../../views/pages/Records/TimeRecordLog";
import { fetchLeadFiltersThunk, fetchLeads } from "../../Slices/salesSlice";
import { createLoginWorkHistoryAsync } from "../../Slices/Thunk/LoginThunk";
import Finance from "../../views/pages/Finance/finance";
import { setLayoutConfig } from "../../Slices/taskSlice";
import CSVEmailUploader from "../../views/pages/emails/emailvalidation";
import EmailVerificationHistory from "../../views/pages/emails/EmailVerificationHistory";
import RingCentral from "../../views/pages/RingCentral/RingCentral";
import CampaignDashboard from "../../views/pages/BulkOutreach/CampaignDashboard";
import CampaignWizard from "../../views/pages/BulkOutreach/CampaignWizard";
import CampaignDetail from "../../views/pages/BulkOutreach/CampaignDetail";
import CampaignComparison from "../../views/pages/BulkOutreach/CampaignComparison";
import PlaybookManager from "../../views/pages/BulkOutreach/PlaybookManager";
import SegmentManager from "../../views/pages/BulkOutreach/SegmentManager";
import AccessManagement from "../../views/pages/AccessManagement/AccessManagement";
import EmployeeManagement from "../../views/pages/AccessManagement/EmployeeManagement";
import { SetNotification } from "../../Slices/socketemail";
import { PersonalMailTab } from "../../views/pages/Outlook/PersonaloutLook";
import { MultiMailTab } from "../../views/pages/Outlook/SalesOutLook";
import SalesOutlookMailbox from "../../views/pages/Outlook/SalesOutlookMailbox";
// Brevo BulkEmails imports removed
import OutlookNew from "../../views/pages/Outlook/OutlookNew";
import NestedDataBucket from "../../views/pages/Profile/NestedDataBucket";
import { setMailList } from "../../Slices/notification";
import { setLoader } from "../../Slices/loaderSlice";
import ListAssets from "../../views/pages/Assets/ListAssets";
import Maintenances from "../../views/pages/Assets/ListMaintenances";
import ListOfWarranties from "../../views/pages/Assets/ListOfWarranties";
import Tool from "../../views/pages/Assets/Tool";
import { fetchAllUsersThunk } from "../../Slices/Thunk/LoginThunk";
import { fetchNestedData } from "../../Slices/dataBucket";
import { getProgress } from "../../Slices/attendenceSlice";
import { fetchEmails } from "../../Slices/sharedEmailSlice";
import FileUploadPreview from "../../views/Brocho/fileUpload";
import DynamicBreadcrumbs from "../../components/DynamicBreadcrumbs";
import TabBar from "../../components/TabBar";
import { openTab, switchTab, updateActiveTabPath } from "../../Slices/tabSlice";
import { SIDEMENU } from "../../databucket";
import Emails from "../../views/Brocho/Emails";
import { Spin } from "antd";
import EmployeePerformanceGraph from "../../views/pages/Dashboards/ClientView";
import EmployeePerformanceEmployeeView from "../../views/pages/Dashboards/EmployeeView";
import ClientMails from "../../views/pages/Clients/ClientMails";
import Mails from "../../views/pages/Employees/Mails";
import JobRequisitionManagement from "../../views/pages/Hiring/JobRequisition";
import JobPosting from "../../views/pages/Hiring/JobPosting";
import InterViewScheduling from "../../views/pages/Hiring/InterviewSchedule";
import OfferManagementData from "../../views/pages/Hiring/Offermanagement";
import JobRequisitionDetails from "../../views/pages/Hiring/JobRequisitionDetails";
import JobPostingList from "../../views/pages/Hiring/JobPostingList";
import JobApplyPage from "../../views/pages/Hiring/JobApplyPage";
import CandidateList from "../../views/pages/Hiring/CandidateList";
import CandidateDetails from "../../views/pages/Hiring/CandidateDetails";
import OfferList from "../../views/pages/Hiring/OfferList";
import CorpMails from "../../views/pages/Outlook/CorpMails";
import Esslattendence from "../../Esslattendence/dashboard";
import Reportesl from "../../Esslattendence/report";
import { fetchEmployeeAccess } from "../../Slices/employeeslice";
import { AccessKeys } from "../../components/Desktop/accesskeys";
import Invoice from "../../views/pages/Invoice/Invoice";
import AllInvoices from "../../views/pages/Clients/Invoice/All-Invoices";
import InterviewList from "../../views/pages/Hiring/InterviewList";
import ActivityHeader from "../../views/pages/Activity/ActivitySummaryHeader";
import ActivityDayDetails from "../../views/pages/Activity/ActivityDayDetails";
import EmployeeActivity from "../../views/pages/Activity/EmployeeActivity";
import Playbook from "../../views/pages/Playbook";
import ClientBillingReport from "../../views/pages/Report/ClientBillingReport";
import EmployeePerformanceReport from "../../views/pages/Report/EmployeePerformanceReport";
import ClientConfidentialAccess from "../../views/pages/AccessManagement/ClientManagement";
import DeviceManagement from "../../views/pages/AccessManagement/DeviceManagement";
import HandbookManagement from "../../views/pages/AccessManagement/HandbookManagement";
import PersonalOutlookAccess from "../../views/pages/AccessManagement/PersonalOutlookAccess";
import ClientOutlookAccess from "../../views/pages/AccessManagement/ClientOutlookAccess";
import SalesOutlookAccess from "../../views/pages/AccessManagement/SalesOutlookAccess";
import ClientLoginsManagement from "../../views/pages/AccessManagement/ClientLoginsManagement";
import AccessSlotsPage from "../../views/pages/AccessManagement/AccessSlotsPage";
import MyHandbooks from "../../views/pages/Employees/MyHandbooks";
import HandbookViewer from "../../views/pages/Employees/HandbookViewer";
import OperationsDashboard from "../../views/pages/Report/OperationsDashboard";
import SalesDashboard from "../../views/pages/Report/SalesDashboard";
import MyDashboard from "../../views/pages/Report/MyDashboard";
import ChatPage from "../../views/pages/Chat/ChatPage";
import WhatsAppInbox from "../../views/pages/WhatsApp/WhatsAppInbox";
import WhatsAppAdmin from "../../views/pages/WhatsApp/WhatsAppAdmin";
import ChatSocketListener from "../../views/pages/Chat/ChatSocketListener";
import ChatWidget from "../../views/pages/Chat/ChatWidget";
const Payroll = React.lazy(() => import("../../views/pages/Payroll/Payroll"));
const MyPayslip = React.lazy(() => import("../../views/pages/Payroll/MyPayslip"));

/**
 * TabSyncWithUrl — invisible component that syncs URL ↔ tabs.
 * - In-page navigation (clicking a lead row) → updates the active tab's path
 * - Tab click → navigates to that tab's saved URL
 * - Sidebar click creates new tabs via openTab dispatch (handled in Sidebar)
 */
const TabSyncWithUrl = ({ routes }) => {
  const tabs = useSelector((state) => state.tabs.tabs);
  const activeTabId = useSelector((state) => state.tabs.activeTabId);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const syncingRef = React.useRef(false);

  const titleForPath = (p) => {
    for (const menu of SIDEMENU) {
      if (menu.Subfields) {
        const sub = menu.Subfields.find(s => s.name === p);
        if (sub) return sub.displayName;
      }
    }
    return null;
  };

  // When URL changes from in-page navigation, update the active tab's path
  React.useEffect(() => {
    if (syncingRef.current) return;
    const path = location.pathname;
    if (!path || path === "/") return;

    // If there's an active tab, update its path to follow the navigation
    if (activeTabId) {
      const activeTab = tabs.find((t) => t.id === activeTabId);
      if (activeTab && activeTab.path !== path) {
        dispatch(updateActiveTabPath({ path, title: titleForPath(path) }));
      }
      return;
    }

    // No active tab yet — create one if the path matches a known route
    const cleanPath = path.startsWith("/") ? path.substring(1) : path;
    const matched = routes.find((r) => {
      const m = matchPath({ path: r.path, end: true }, cleanPath);
      return !!m;
    });
    if (matched) {
      const title = cleanPath.split("/")[0].replace(/([A-Z])/g, " $1").trim() || "Page";
      dispatch(openTab({ path, title }));
    }
  }, [location.pathname]);

  // When active tab changes (clicking a tab in TabBar), navigate to its URL
  const activeTab = tabs.find((t) => t.id === activeTabId);
  React.useEffect(() => {
    if (activeTab && location.pathname !== activeTab.path) {
      syncingRef.current = true;
      navigate(activeTab.path, { replace: true });
      setTimeout(() => { syncingRef.current = false; }, 0);
    }
  }, [activeTabId, activeTab?.path]);

  return null;
};

const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
};


// Exported for the Webtop window manager (Phase 16) — uses only module-level imports.
    export const superAdminRoutes = [
        { id: 1, path: "request", element: <Requests /> },
        { id: 2, path: "request/:id", element: <Requests /> },
        { id: 3, path: "adminattendance", element: <AttendenceAdmin /> },
        { id: 4, path: "employees", element: <AllEmpoyee /> },
        { id: 5, path: "employees/:Empid", element: <Profile key={Math.random()} /> },
        { id: 6, path: "employees-list", element: <EmployeeListFilter /> },
        { id: 7, path: "profile", element: <Profile /> },
        { id: 8, path: "clients", element: <Clients /> },
        { id: 9, path: "clients/:id", element: <ClientProfiles /> },
        { id: 112, path: "Addclients", element: <ClientProfiles /> },
        { id: 10, path: "clients-list", element: <ClientList /> },
        { id: 11, path: "sales", element: <Sales /> },
        { id: 12, path: "sales/:id", element: <SaleDetails /> },
        { id: 107, path: "email-history", element: <SalesEmailHistory /> },
        { id: 108, path: "email-templates", element: <EmailTemplates /> },
        { id: 109, path: "LeadAnalytics", element: <LeadAnalytics /> },
        { id: 110, path: "UnsubscribeHistory", element: <UnsubscribeHistory /> },
        { id: 120, path: "bulk-outreach", element: <CampaignDashboard /> },
        { id: 121, path: "bulk-outreach/new", element: <CampaignWizard /> },
        { id: 122, path: "bulk-outreach/:id", element: <CampaignDetail /> },
        { id: 123, path: "bulk-outreach/compare", element: <CampaignComparison /> },
        { id: 124, path: "bulk-outreach/playbooks", element: <PlaybookManager /> },
        { id: 125, path: "bulk-outreach/segments", element: <SegmentManager /> },
        { id: 13, path: "emails", element: <Mails /> },
        { id: 14, path: "EmployeeReport", element: <EmployeeReport /> },
        { id: 15, path: "ClientReport", element: <ClientReport /> },
        { id: 16, path: "container", element: <ConditionMenu /> },
        { id: 17, path: "Mail", element: <BulkEmail /> },
        { id: 18, path: "dataBucket", element: <FieldManager /> },

        { id: 20, path: "OverwritingHistory", element: <OverwritingHistory /> },
        { id: 21, path: "DynamicRoute", element: <ConditionMenuRoute /> },
        { id: 22, path: "SalesStats", element: <SalesStats /> },
        { id: 23, path: "RequestStats", element: <RequestsStats /> },
        { id: 24, path: "adminleaves", element: <AdminLeave /> },
        { id: 25, path: "holidays", element: <Holidays /> },
        { id: 26, path: "leave-settings", element: <LeaveSettings /> },
        { id: 27, path: "employee-leaves", element: <EmployeeLeave /> },
        { id: 28, path: "employeeattendance", element: <AttendanceEmployee /> },
        { id: 29, path: "SalesReport", element: <ClientReport /> },
        { id: 31, path: "reset-token", element: <ResetToken /> },
        { id: 32, path: "Tasks/ViewTasks", element: <AdminTasks /> },
        { id: 33, path: "Tasks/MyTasks", element: <UserTasks /> },
        { id: 34, path: "EmailValidation", element: <CSVEmailUploader /> },
        { id: 35, path: "EmailVerificationHistory", element: <EmailVerificationHistory /> },
        /* Brevo BulkEmails routes removed — replaced by Bulk Outreach */
        { id: 48, path: "personalOutlook", element: <PersonalMailTab /> },
        { id: 49, path: "Outlook", element: <MultiMailTab /> },
        { id: 101, path: "salesOutlook", element: <SalesOutlookMailbox /> },
        { id: 107, path: "OutlookNew", element: <OutlookNew /> },
        { id: 50, path: "IdCard", element: <IDCard /> },
        { id: 52, path: "Finance", element: <Finance /> },
        { id: 53, path: "ringcentral", element: <RingCentral /> },
        { id: 54, path: "RecordClientReport", element: <RecordClientReport /> },
        { id: 55, path: "RecordEmployeeReport", element: <RecordEmployeeReport /> },
        { id: 56, path: "RecordTimeLog", element: <RecordTimeLog /> },
        { id: 57, path: "ListOfAssets", element: <ListAssets /> },
        { id: 58, path: "AssetTool", element: <Tool /> },
        { id: 59, path: "ListOfWarranties", element: <ListOfWarranties /> },
        { id: 60, path: "dropdownManager", element: <NestedDataBucket /> },
        { id: 61, path: "ListOfMaintenances", element: <Maintenances /> },
        { id: 62, path: "Brochure/Fileupload", element: <FileUploadPreview /> },
        { id: 63, path: "Brochure/emails", element: <Emails /> },
        { id: 65, path: "ClientMails", element: <ClientMails /> },
        { id: 66, path: "Dashboard", element: <EmployeePerformanceGraph /> },
        { id: 67, path: "EmployeeView", element: <EmployeePerformanceEmployeeView /> },
        { id: 68, path: "JobRequisition", element: <JobRequisitionManagement /> },
        { id: 69, path: "JobPosting", element: <JobPostingList /> },
        { id: 70, path: "InterviewScheduling", element: <InterviewList /> },
        { id: 71, path: "OfferManagement", element: <OfferList /> },
        { id: 72, path: "JobRequisition/:id", element: <JobRequisitionManagement /> },
        { id: 73, path: "careers/apply/:slug", element: <JobApplyPage /> },
        { id: 74, path: "CandidateList", element: <CandidateList /> },
        { id: 75, path: "CandidateList/:id", element: <CandidateDetails /> },
        { id: 76, path: "InterviewScheduling/:id", element: <InterViewScheduling /> },
        { id: 77, path: "offerManagement/:id", element: <OfferManagementData /> },
        { id: 78, path: "CorpWebMails", element: <CorpMails /> },
        { id: 79, path: "JobPosting/:id", element: <JobPosting /> },
        { id: 80, path: "BiometricAttendance", element: <Esslattendence /> },
        { id: 81, path: "BiometricAttendance/Reports", element: <Reportesl /> },
        { id: 82, path: "RouteAccess", element: <AccessManagement /> },
        { id: 83, path: "EmployeeAccess", element: <EmployeeManagement /> },
        { id: 84, path: "AccessKeys", element: <AccessKeys /> },
        { id: 85, path: "Leads", element: <Sales /> },
        { id: 86, path: "Pipeline", element: <Pipeline /> },
        { id: 1086, path: "sales/manual-reports", element: <MyManualReports /> },
        { id: 1087, path: "sales/manual-reports/team", element: <TeamManualReports /> },
        { id: 87, path: "Manual-Invoice", element: <Invoice /> },
        { id: 88, path: "All-Invoices", element: <AllInvoices /> },
        { id: 89, path: "activity", element: <EmployeeActivity /> },
        { id: 90, path: "activity/user/:id", element: <ActivityHeader /> },
        { id: 91, path: "activity/device/:id", element: <ActivityHeader /> },
        { id: 92, path: "activity/user/:id/:date", element: <ActivityDayDetails /> },
        { id: 93, path: "activity/device/:id/:date", element: <ActivityDayDetails /> },
        { id: 94, path: "playbook", element: <Playbook /> },
        { id: 95, path: "client-access", element: <ClientConfidentialAccess /> },
        { id: 96, path: "device-access", element: <DeviceManagement /> },
        { id: 97, path: "handbook-access", element: <HandbookManagement /> },
        { id: 98, path: "personal-outlook-access", element: <PersonalOutlookAccess /> },
        { id: 99, path: "client-outlook-access", element: <ClientOutlookAccess /> },
        { id: 100, path: "sales-outlook-access", element: <SalesOutlookAccess /> },
        { id: 98, path: "my-handbooks", element: <MyHandbooks /> },
        { id: 99, path: "my-handbooks/:handbookId", element: <HandbookViewer /> },
        { id: 100, path: "ClientBillingReport", element: <ClientBillingReport /> },
        { id: 101, path: "EmployeePerformanceReport", element: <EmployeePerformanceReport /> },
        { id: 102, path: "OperationsDashboard", element: <OperationsDashboard /> },
        { id: 103, path: "MyDashboard", element: <MyDashboard /> },
        { id: 104, path: "SalesDashboard", element: <SalesDashboard /> },
        { id: 105, path: "chat", element: <ChatPage /> },
        { id: 106, path: "chat/:conversationId", element: <ChatPage /> },
        { id: 107, path: "announcements", element: <Announcements /> },
        { id: 108, path: "mobile-route-access", element: <MobileRouteManagement /> },
        { id: 109, path: "client-logins", element: <ClientLoginsManagement /> },
        { id: 110, path: "access-slots", element: <AccessSlotsPage /> },
        // WhatsApp Business inbox (Access Management routes: /whatsapp, /whatsapp-admin)
        { id: 140, path: "whatsapp", element: <WhatsAppInbox /> },
        { id: 141, path: "whatsapp-admin", element: <WhatsAppAdmin /> },
        {
            id: 130,
            path: "payroll",
            element: (
                <React.Suspense fallback={<div style={{ padding: 40 }}><Spin size="large" /></div>}>
                    <Payroll />
                </React.Suspense>
            ),
        },
        {
            id: 131,
            path: "my-payslip",
            element: (
                <React.Suspense fallback={<div style={{ padding: 40 }}><Spin size="large" /></div>}>
                    <MyPayslip />
                </React.Suspense>
            ),
        },
    ];

const AppContainer = () => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem('token');


    useEffect(() => {
        dispatch(setLayoutConfig({
            colorSchema: 'blue',
            layout: 'vertical',
            layoutWidth: 'fixed',
            layoutPos: 'fluid',
            topbarTheme: 'light',
            layoutSized: 'lg',
            layoutStyling: 'default',
            layoutSidebarStyle: 'dark',
        }))
    }, [dispatch]);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const CurrentUserAccess = useSelector((state) => state?.employee?.currentEmployeeAccess);


    const filteredSuperAdminRoutes = [];
    filteredSuperAdminRoutes.push(
        { id: 75, path: "profile", element: <Profile /> },
        { id: 76, path: "Addclients", element: <ClientProfiles /> },
        { id: 77, path: "employees-list", element: <EmployeeListFilter /> },
        { id: 78, path: "clients-list", element: <ClientList /> },
        { id: 103, path: "MyDashboard", element: <MyDashboard /> },
        { id: 105, path: "chat", element: <ChatPage /> },
        { id: 106, path: "chat/:conversationId", element: <ChatPage /> },
    );

    CurrentUserAccess?.routes.forEach((menuItem) => {
        // if (!menuItem.status) return;
        const cleanedMenuName = menuItem.replace(/^\//, "").toLowerCase();
        const matchedRoutes = superAdminRoutes?.filter(route =>
            route.path.toLowerCase() === cleanedMenuName ||
            route.path.toLowerCase().startsWith(`${cleanedMenuName}/`) ||
            route.path.toLowerCase() === "profile"
        );
        if (matchedRoutes.length > 0) {
            matchedRoutes.forEach(route => {
                filteredSuperAdminRoutes.push(route);
            });
        }

    });
    
    const SidebarLayout = () => (
        <>
            <Header />
            <Sidebar />
            <TabBar />
            <TabSyncWithUrl routes={routes} />
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <DynamicBreadcrumbs routes={routes} />
                    <Outlet />
                </div>
            </div>
        </>
    );


    const mobileResponsive = (event) => {
        const excludedHeader = document.querySelector(".header");
        const excludedSidebar = document.querySelector(".sidebar");

        if (
            (!excludedHeader || !excludedHeader.contains(event.target)) &&
            (!excludedSidebar || !excludedSidebar.contains(event.target))
        ) {
            document.body.classList.remove("slide-nav");
        }
    };

    const routes = filteredSuperAdminRoutes
    const loginData = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const personalMail = loginData?.email;
    const mails = loginData?.emailSettings
        ?.filter(item => item.status === true || item.status === "true")
        ?.map(item => item.email) || [];
    const salesMails = loginData?.salesEmailSettings
        ?.filter(item => item.status === true || item.status === "true")
        ?.map(item => item.email)
        ?.filter(Boolean) || [];
    const EmpMails = Array.from(new Set([...mails, ...salesMails, personalMail].filter(Boolean)));

    useEffect(() => {
        if (EmpMails?.length > 0) {
            dispatch(setMailList(EmpMails));
        }
    }, [dispatch, JSON.stringify(EmpMails)])

    const userStatus = useSelector((state) => state?.loginUserInfo?.userStatus)
    const userId = parseJwt(token)?.id;
    const [stored] = useState(() => JSON.parse(localStorage.getItem('uniqueEmailIds') || '[]'));

    useEffect(() => {
        dispatch(SetNotification(stored));
    }, [dispatch, stored])

    useEffect(() => {
        const fetchAllData = async () => {
            setIsLoading(true);
            dispatch(setLoader(true));

            if (!userStatus && token && userId) {
                try {
                    // Phase 1 — critical: needed for sidebar, routing, and user context
                    // Race against 12s timeout so a hung API call never freezes the app
                    await Promise.race([
                        Promise.all([
                            dispatch(fetchUserDetails(userId)),
                            dispatch(fetchEmployeeAccess({ userId })),
                            dispatch(fetchAllUsersThunk(userId)),
                            dispatch(fetchDynamicRoutes()),
                            dispatch(fetchData()),
                        ]),
                        new Promise(resolve => setTimeout(resolve, 12000)),
                    ]);
                } catch (error) {
                    console.error("Error fetching critical data:", error);
                }

                // Show the app immediately after critical data is ready
                dispatch(setLoader(false));
                setIsLoading(false);

                // Phase 2 — background: heavy data that doesn't block the UI
                // silent: true prevents these from re-triggering the full-screen loader
                Promise.all([
                    dispatch(fetchLeads({ silent: true })),
                    dispatch(fetchLeadFiltersThunk({ silent: true })),
                    dispatch(fetchClients({ silent: true })),
                    dispatch(getProgress({ id: userId })),
                    dispatch(fetchNestedData({ silent: true })),
                    dispatch(createLoginWorkHistoryAsync(
                        { userId: userId, title: "", description: "", companyname: "BlueplanIt", department: "", task: 'login', date: "", startTime: new Date().toISOString(), endTime: "" }
                    )),
                    dispatch(fetchEmails({ silent: true })),
                ]).catch(error => {
                    console.error("Error fetching background data:", error);
                });
            } else {
                dispatch(setLoader(false));
                setIsLoading(false);
            }
        };

        fetchAllData();
    }, [dispatch, userId, userStatus]);


    return (
        <>
            <Loader />
            {isLoading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: isLoading ? "flex" : "none",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.34)",
                        zIndex: 9999,
                    }}
                >
                    <Spin size="large" spinning={true} />
                </div>
            )}
            <div className="main-wrapper" onClick={mobileResponsive}>
                {!isLoading && (
                    <Routes>
                        <Route path="/*" element={<SidebarLayout />}>
                            {routes.map((item) => (
                                <Route key={item.id} path={item.path} element={item.element} />
                            ))}
                            <Route path="*" element={<Error404 />} />
                        </Route>
                    </Routes>
                )}
                <NotificationListener />
                <ChatSocketListener />
                <ChatWidget />
            </div>
        </>
    );

}
export default AppContainer;
